'use client';
import { Button } from '@/shared/components/primitives/button';
import { useAppStore } from '@/features/shared/app-store';

type OpenCookieSettingsButtonProps = {
  buttonTitle?: string;
  showAsTextLink?: boolean;
};

export const OpenCookieSettingsButton = ({
  buttonTitle,
  showAsTextLink = false,
}: OpenCookieSettingsButtonProps) => {
  const openCookieSettings = useAppStore((state) => state.consentActions.toggleCookieBanner);
  const handleOpenCookieSettings = () => {
    openCookieSettings();
  };
  return (
    <>
      {showAsTextLink ? (
        <button
          className='focus-visible:ring-primary lg:hover:text-text-hover underline focus:outline-hidden focus-visible:ring-2 focus-visible:ring-offset-2'
          onClick={handleOpenCookieSettings}
        >
          {buttonTitle}
        </button>
      ) : (
        <Button className='min-w-52' onClick={handleOpenCookieSettings}>
          {buttonTitle}
        </Button>
      )}
    </>
  );
};
